export default __webpack_public_path__ + "static/media/paypoint-logo.6fef72cd.svg";